// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"c2ff0b21","121":"ebed6590","231":"e5aefad2","700":"845dd4e9","778":"57c07193","846":"cc1eb3f2"}[chunkId] + ".chunk.js";
};